// @ts-ignore
// @ts-ignore

import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import "../index.css";

// @ts-ignore
import NseImg from "@/assets/images/NSE.jpg";
// @ts-ignore
import BSEImg from "@/assets/images/BSE.jpg";
// @ts-ignore
import SEBIImg from "@/assets/images/SEBI.jpg";
// @ts-ignore
import mcxImg from "@/assets/images/mcx.png";
// @ts-ignore
import NCDXImg from "@/assets/images/NCDX.jpg";

// @ts-ignore
import BSE from "@/assets/images/BSE_Certificate.jpg";
// @ts-ignore
import MCX from "@/assets/images/MCX.jpg";
// @ts-ignore
import SEBI_Cerificate from "@/assets/images/SEBI_Cerificate.jpg";
// @ts-ignore
import ZB7_NCDEX from "@/assets/images/ZB7_NCDEX.jpg";
// @ts-ignore
import ZB7_NSE from "@/assets/images/ZB7_NSE.jpg";
// @ts-ignore


// const cerifi = [
//   {
//     id: 1,
//     title: "NSE - National Stock Exchange",
//     image: NseImg,
//   },
//   {
//     id: 2,
//     title: "BSE - Bombay Stock Exchange",
//     image: BSEImg,
//   },
//   {
//     id: 3,
//     title: "SEBI - Securities and Exchange Board of India",
//     image: SEBIImg,
//   },
//   {
//     id: 4,
//     title: "MCX - Multi Commodity Exchange",
//     image: mcxImg,
//   },
//   {
//     id: 5,
//     title: "NCDEX - National Commodity & Derivatives Exchange",
//     image: NCDXImg,
//   },
// ];
export default function Certificates() {
  const [activeTab, setActiveTab] = useState(null);
  const tabs = [
    {
      id: 1,
      title: "NSE - National Stock Exchange",
      image: NseImg,
      image1: ZB7_NSE,
      
    },

    {
      id: 2,
      title: "BSE - Bombay Stock Exchange",
      image: BSEImg,
      image1: BSE,
    },
    {
      id: 3,
      title: "SEBI - Securities and Exchange Board of India",
      image: SEBIImg,
      image1: SEBI_Cerificate,
    },
    {
      id: 4,
      title: "MCX - Multi Commodity Exchange",
      image: mcxImg,
      content: "This is the Pricing section.",
      image1: MCX,
    },
    {
      id: 5,
      title: "NCDEX - National Commodity & Derivatives Exchange",
      image: NCDXImg,
      content: "This is the Pricing section.",
      image1: ZB7_NCDEX,
    },
  ];
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const selectedTab = tabs.find((item) => item.id === activeTab);
 
  return (
    <section
      id="certificates"
      className="py-12 sm:py-16 md:py-24 bg-secondary/30"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground mb-4 sm:mb-6">
            Certificates
          </h2>
        </div>

        {/* Exchange Logos */}

        <div className="flex flex-wrap items-center justify-around mb-8 sm:mb-10">
          {/* Close Button */}
          {activeTab && (
            <div className="close-wrapper">
              <button className="close-btn" onClick={() => setActiveTab(null)}>
                ✕ Close
              </button>
            </div>
          )}
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`${activeTab === tab.id ? "active" : ""} flex flex-col items-center group cursor-default`}
              onClick={() => setActiveTab(activeTab === tab.id ? null : tab.id)}
            >
              <div className="w-40 h-24 md:w-48 md:h-28 rounded-lg bg-white border border-border flex items-center justify-center p-4 group-hover:border-accent/50 transition-colors mb-2 cursor-pointer">
                <img
                  src={tab.image}
                  alt={tab.title}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          ))}
        </div>
        {/* Content */}
          {activeTab && selectedTab && (
  <div className="popup-overlay ">

    <div className="popup bg-secondary/30">

      {/* Top Bar */}
      <div className="popup-topbar">

        <div className="zoom-controls">
          <button
            onClick={() => {
              setZoom((prev) => Math.min(prev + 0.1, 3));
            }}
          >
            +
          </button>

          <span>{Math.round(zoom * 100)}%</span>

          <button
            onClick={() => {
              setZoom((prev) => {
                const newZoom = Math.max(prev - 0.1, 1);

                if (newZoom === 1) {
                  setPosition({ x: 0, y: 0 });
                }

                return newZoom;
              });
            }}
          >
            −
          </button>
        </div>

        <button
          className="close-btn"
          onClick={() => {
            setActiveTab(null);
            setZoom(1);
            setPosition({ x: 0, y: 0 });
          }}
        >
          ✕
        </button>

      </div>

      {/* Image */}
      <div
        className="popup-image-wrapper"

        onPointerDown={(e) => {
          if (zoom <= 1) return;

          setIsDragging(true);

          e.currentTarget.setPointerCapture(e.pointerId);

          setDragStart({
            x: e.clientX - position.x,
            y: e.clientY - position.y,
          });
        }}

        onPointerMove={(e) => {
          if (!isDragging || zoom <= 1) return;

          setPosition({
            x: e.clientX - dragStart.x,
            y: e.clientY - dragStart.y,
          });
        }}

        onPointerUp={(e) => {
          setIsDragging(false);

          if (e.currentTarget.hasPointerCapture(e.pointerId)) {
            e.currentTarget.releasePointerCapture(e.pointerId);
          }
        }}

        onPointerCancel={() => {
          setIsDragging(false);
        }}
      >

        <img
          src={selectedTab.image1}
          alt={selectedTab.title}
          className="popup-image"
          draggable="false"
          style={{
            transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`,
          }}
        />

      </div>

    </div>

  </div>
)}
        {/* {activeTab && (
          <div className="tab-content">
             
              <button
                className="close-btn"
                onClick={() => setActiveTab(null)}
              >
                ✕
              </button>
            {tabs.map(
              (tab) =>
                activeTab === tab.id && (
                  <div key={tab.id}>
                    <h2>{tab.title}</h2>
                    <p>{tab.content}</p>
                  </div>
                ),
            )}
          </div>
        )} */}
        {/* Compliance Note */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-card border border-border rounded-lg p-6 flex items-start gap-4">
            <ShieldCheck className="h-6 w-6 text-accent flex-shrink-0 mt-1" />
            <p className="text-sm text-muted-foreground leading-relaxed">
              Investment in securities market are subject to market risks, read
              all the related documents carefully before investing
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
